import { useDeploymentCountry } from "../../providers/DeploymentCountryProvider";

export const useProductEosb = () => {
  const { isDeployedIn } = useDeploymentCountry();
  const isActive = isDeployedIn("ae");
  return { isActive };
};
